require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./container"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./container", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./container"), require("./utils")) : factory(root["./container"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32299__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[1683],{

/***/ 526:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _reactDom = __webpack_require__(66405);
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _container = _interopRequireDefault(__webpack_require__(32299));
var _utils = __webpack_require__(78815);
var _Slideout = _interopRequireDefault(__webpack_require__(62725));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const slideoutClassName = _Slideout.default.SlideoutClassName.replace(/"/g, '');
const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
class Slideout extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_onTransitionEnd", e => {
      if (e.propertyName === 'transform') {
        // fires the onOpend/onHidden callback when sliding transition is end
        const {
          active,
          onOpened,
          onHidden
        } = this.props;
        if (active) {
          this._addClickAwayEventListener();
          onOpened(e);
        } else {
          onHidden(e);
        }
        this.setState({
          showChildren: active
        });
      }
    });
    (0, _defineProperty2.default)(this, "_onAnimationEnd", e => {
      const {
        active,
        onOpened
      } = this.props;
      this._addClickAwayEventListener();
      onOpened(e);
      this.setState({
        showChildren: active,
        hasAnimation: false
      });
      (0, _reactDom.findDOMNode)(this).removeEventListener('animationend', this._onAnimationEnd);
    });
    (0, _defineProperty2.default)(this, "_clickAwayEventListener", e => {
      const {
        onClickAway,
        containerRef
      } = this.props;
      const parent = !containerRef ? this : containerRef;
      if (!(0, _reactDom.findDOMNode)(parent).contains(e.target)) {
        onClickAway(e);
      }
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      const {
        onClose
      } = this.props;
      if (isKey(e, keyNames.ESCAPE)) {
        onClose(e);
        (0, _reactDom.findDOMNode)(this).blur();
      }
    });
    (0, _defineProperty2.default)(this, "_onResizeStop", (event, data) => {
      const {
        onClickAway,
        onResizeStop
      } = this.props;
      const iFrames = document.querySelectorAll('iframe');
      const {
        iFrameZIndexes
      } = this.state;
      if (onClickAway) {
        // temporarily remove the clickaway listener to prevent the slideout being automatically collapsed if it reaches the max width/height
        window.removeEventListener('click', this._clickAwayEventListener);
        setTimeout(() => {
          window.addEventListener('click', this._clickAwayEventListener);
        });
      }
      iFrames.forEach((iFrame, index) => {
        iFrame.style.zIndex = iFrameZIndexes[index];
      });
      onResizeStop(event, data);
    });
    (0, _defineProperty2.default)(this, "_onResizeStart", (event, data) => {
      const {
        onResizeStart
      } = this.props;
      const iFrames = document.querySelectorAll('iframe');
      iFrames.forEach(iFrame => {
        iFrame.style.zIndex = '-1';
      });
      onResizeStart(event, data);
    });
    const {
      active: _active,
      animationOnRender
    } = this.props;
    this.state = {
      showChildren: _active,
      hasAnimation: animationOnRender,
      iFrameZIndexes: []
    };
  }
  componentDidMount() {
    const {
      active,
      animationOnRender
    } = this.props;
    const {
      iFrameZIndexes
    } = this.state;
    const iFrames = document.querySelectorAll('iframe');
    iFrames.forEach((iFrame, index) => {
      iFrameZIndexes[index] = iFrame.style.zIndex || 'auto';
    });
    this.setState({
      iFrameZIndexes
    });
    if (active) {
      this._addListeners();
      if (!animationOnRender) {
        setTimeout(() => {
          // when slideout is opened after mount and no animation on render , adding the clickAway event listener, since in other cases clickAway listener is added when sliding out transition is end,
          // Adding this listener after a cycle is to prevent unexpected closing effect from a clicking event
          this._addClickAwayEventListener();
        });
      }
    }
  }
  componentDidUpdate(prevProps, prevStates) {
    const {
      active: prevActiveProp
    } = prevProps;
    const {
      active: curActiveProp,
      autoFocus
    } = this.props;
    const {
      showChildren: prevShowChildrenState
    } = prevStates;
    const {
      showChildren: curShowChildrenState
    } = this.state;
    if (!prevActiveProp && curActiveProp) {
      this._addListeners();
    } else if (prevShowChildrenState && !curShowChildrenState) {
      this._removeListeners();
    } else if (!prevShowChildrenState && curShowChildrenState && autoFocus) {
      (0, _reactDom.findDOMNode)(this).focus();
    }
  }
  componentWillUnmount() {
    this._removeListeners();
  }
  _addClickAwayEventListener() {
    const {
      onClickAway
    } = this.props;
    if (onClickAway) {
      window.addEventListener('click', this._clickAwayEventListener);
    }
  }
  _addListeners() {
    const {
      hasAnimation
    } = this.state;
    (0, _reactDom.findDOMNode)(this).addEventListener('transitionend', this._onTransitionEnd);
    if (hasAnimation) {
      (0, _reactDom.findDOMNode)(this).addEventListener('animationend', this._onAnimationEnd);
    }
  }
  _removeListeners() {
    const {
      onClickAway
    } = this.props;
    if (onClickAway) {
      window.removeEventListener('click', this._clickAwayEventListener);
    }
    (0, _reactDom.findDOMNode)(this).removeEventListener('transitionend', this._onTransitionEnd);
  }
  render() {
    const {
      width,
      height,
      children,
      style,
      active,
      toDirection,
      resizable,
      resizeDirection,
      resizeMaxConstraintsX,
      resizeMaxConstraintsY,
      resizeMinConstraintsX,
      resizeMinConstraintsY,
      onResize,
      className,
      ...others
    } = this.props;
    const {
      showChildren,
      hasAnimation
    } = this.state;
    const slideoutComponentClass = (0, _utils.classnames)(`${slideoutClassName}`, {
      [`${toDirection}`]: toDirection,
      hasAnimation,
      active
    });
    const sharedProps = {
      ...sanitize(others, Slideout),
      tabIndex: -1,
      // can only be focusable programatically, not through TAB key
      className: `${slideoutComponentClass} ${className}`,
      onKeyDown: this._onKeyDown
    };
    const slideoutChildren = /*#__PURE__*/_react.default.createElement("div", {
      className: `${slideoutClassName}-children`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `${slideoutClassName}-children-wrapper`,
      style: {
        ...style
      }
    }, children));
    if (resizable) {
      const resizeProps = {
        resizable: true,
        resizeDirection,
        resizeMaxConstraintsX,
        resizeMaxConstraintsY,
        resizeMinConstraintsX,
        resizeMinConstraintsY,
        onResizeStop: this._onResizeStop,
        onResizeStart: this._onResizeStart,
        onResize
      };
      return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sharedProps, resizeProps, {
        width: width,
        height: height
      }), (active || showChildren) && slideoutChildren);
    }
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, sharedProps, {
      style: {
        width,
        height
      }
    }), (active || showChildren) && slideoutChildren);
  }
}
exports["default"] = Slideout;
(0, _defineProperty2.default)(Slideout, "propTypes", {
  /** Toggles to show the slide in and out effect, by default, slideout pannel is hidden */
  active: _propTypes.default.bool,
  /** Custom styles passed to the slideout */
  style: _propTypes.default.object,
  autoFocus: _propTypes.default.bool,
  /** Slideout direction */
  toDirection: _propTypes.default.oneOf(['left', 'right', 'top', 'bottom']),
  /** Width of the slideout */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Height of the slideout */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /** Resizability flag, it will be horizontally resizable if turned to true */
  resizable: _propTypes.default.bool,
  /** Defines resize directions, can be vertical, horizontal or both direction */
  resizeDirection: _propTypes.default.oneOf(['x', 'y', 'both', 'none']),
  /** Callback function called after panel is hidden */
  onHidden: _propTypes.default.func,
  onClose: _propTypes.default.func,
  /** Callback function called after panel is opened */
  onOpened: _propTypes.default.func,
  /** Callback function called when click away, typical implemention to achieve auto collapse is to set the active prop to false */
  onClickAway: _propTypes.default.func,
  onResize: _propTypes.default.func,
  onResizeStart: _propTypes.default.func,
  onResizeStop: _propTypes.default.func,
  /** Works together with onClickAway callback. Defines an area where clickaway callback function won't trigger. By default this area is this slideout node itself */
  containerRef: _propTypes.default.object,
  children: _propTypes.default.node,
  resizeMinConstraintsX: _propTypes.default.number,
  resizeMinConstraintsY: _propTypes.default.number,
  resizeMaxConstraintsX: _propTypes.default.number,
  resizeMaxConstraintsY: _propTypes.default.number,
  className: _propTypes.default.string,
  animationOnRender: _propTypes.default.bool
});
(0, _defineProperty2.default)(Slideout, "defaultProps", {
  active: false,
  toDirection: 'right',
  width: '100%',
  height: '100%',
  resizable: false,
  onHidden: () => {},
  onOpened: () => {},
  onClose: () => {},
  onResizeStart: () => {},
  onResizeStop: () => {},
  onResize: () => {},
  className: '',
  autoFocus: true,
  style: {},
  animationOnRender: false
});

/***/ }),

/***/ 71772:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _Slideout = _interopRequireDefault(__webpack_require__(526));
exports["default"] = _Slideout.default;
exports.Slideout = _Slideout.default;

/***/ }),

/***/ 55717:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, "@keyframes sliding-right{0%{transform:translateX(0%)}100%{transform:translateX(100%)}}@keyframes sliding-left{0%{transform:translateX(0%)}100%{transform:translateX(-100%)}}@keyframes sliding-top{0%{transform:translateY(0%)}100%{transform:translateY(-100%)}}@keyframes sliding-bottom{0%{transform:translateY(0%)}100%{transform:translateY(100%)}}.ba-common-slideout{position:absolute;opacity:0;visibility:hidden}.ba-common-slideout:focus{outline:none}.ba-common-slideout.react-resizable{position:absolute}.ba-common-slideout-children{height:100%;width:100%;position:relative;opacity:.99}.ba-common-slideout-children-wrapper{background-color:#fff;width:100%;height:100%}.ba-common-slideout-children .ba-common-slideout{z-index:-1}.ba-common-slideout.is-active{opacity:1;visibility:visible}.ba-common-slideout:not(.is-active) .ba-common-slideout{opacity:0;visibility:hidden}.ba-common-slideout.is-right{top:0;right:0}.ba-common-slideout.is-right.is-active{transform:translateX(100%)}.ba-common-slideout.is-right.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-right;animation-duration:.4s}.ba-common-slideout.is-left{top:0;left:0}.ba-common-slideout.is-left.is-active{transform:translateX(-100%)}.ba-common-slideout.is-left.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-left;animation-duration:.4s}.ba-common-slideout.is-top{left:0;top:0}.ba-common-slideout.is-top.is-active{transform:translateY(-100%)}.ba-common-slideout.is-top.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-top;animation-duration:.4s}.ba-common-slideout.is-bottom{left:0;bottom:0}.ba-common-slideout.is-bottom.is-active{transform:translateY(100%)}.ba-common-slideout.is-bottom.is-active.is-hasAnimation{animation-fill-mode:forwards;animation-name:sliding-bottom;animation-duration:.4s}.ba-common-slideout{transition:transform .4s ease-in-out,opacity .4s ease-in-out,visibility .4s ease-in-out;background-color:#fff}@media screen and (-ms-high-contrast: active){.ba-common-slideout .ba-common-svgIcon{fill:#ff0}.ba-common-slideout .react-resizable-handle{background-color:#595859}}", ""]);

// exports
exports.locals = {
	"SlideoutClassName": "\"ba-common-slideout\""
};

/***/ }),

/***/ 62725:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55717);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_Slideout_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 32299:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32299__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(71772));
/******/ return __webpack_exports__;
/******/ }
]);
});